module.exports = __webpack_public_path__ + "static/img/高新技术企业技术.d4c64daa.png";